import { IConditionalWrapper } from './types';

/**
 * Used for wrapping elements in a conditional way.
 */
const ConditionalWrapper = ({
	condition,
	wrapper,
	children,
}: IConditionalWrapper) => (condition ? wrapper(children) : children);

export default ConditionalWrapper;
